
window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {
  function getCsrfToken() {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  }

  document.querySelectorAll("input[type=radio][name=do_not_sell_my_information]").forEach(function(radio) {
    radio.addEventListener('change', function() {
      var body = new URLSearchParams({ do_not_sell_my_information: radio.value });
      fetch("/account/privacy_settings", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': getCsrfToken()
        },
        credentials: 'same-origin',
        body: body.toString()
      }).catch(function() {
        var msg = document.getElementById("privacy_modal_message");
        if (msg) msg.innerHTML = "<span class='text-danger'>There was an error saving your preferences. Please contact customer support.</span>";
      });
    });
  });

  var privacyModal = document.getElementById('privacy-modal');
  if (privacyModal) {
    privacyModal.addEventListener('shown.bs.modal', function() {
      fetch("/account/privacy_settings_initialize", { credentials: 'same-origin' })
        .catch(function() {
          var msg = document.getElementById("privacy_modal_message");
          if (msg) msg.innerHTML = "<span class='text-danger'>There was an error retrieving your preferences. Please contact customer support.</span>";
        });
    });
  }
});
